import { Link } from "react-router-dom";

const TrackOrder = ({ trackOrder, getTracking, orderNo: fallbackOrderNo }) => {
    const trackingResponse = trackOrder || getTracking || {};

    const formatDate1 = (dateString) => {
        if (!dateString) return null;

        const date = new Date(dateString);

        const formattedDate = date.toLocaleString("en-US", {
            month: "short",
            day: "numeric",
        });

        const formattedTime = date.toLocaleString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });

        return (
            <div>
                <div className="track_date">{formattedDate}</div>
                <div className="track_time">{formattedTime}</div>
            </div>
        );
    };

    const shipmentId = trackingResponse?.shiprocket_shipment_id;
    const trackingEntry = shipmentId
        ? trackingResponse?.tracking?.[shipmentId]
        : Object.values(trackingResponse?.tracking || {})?.[0];
    const trackingData =
        trackingEntry?.tracking_data ||
        trackingResponse?.tracking_data ||
        trackingResponse?.data?.tracking_data;
    const shipmentTrack = trackingData?.shipment_track || [];
    const shipmentActivities = trackingData?.shipment_track_activities || [];
    const orderNo =
        trackingResponse?.shiprocket_order?.data?.channel_order_id ||
        trackingResponse?.order_id ||
        fallbackOrderNo;
    const orderStatus =
        trackingResponse?.shiprocket_status ||
        trackingResponse?.order_status ||
        trackingData?.shipment_status ||
        "";

    return (
        <div className="track-order-popup">
            {trackingResponse?.shiprocket_order_id ? (
                <p className="track_order_status_id">{trackingResponse.shiprocket_order_id}</p>
            ) : null}

            {trackingData != null ? (
                <div>
                    <div>
                        {shipmentTrack.map((element, i) => (
                            <div key={i}>
                                <div>
                                    <span>OrderNo. :</span>
                                    <span>{orderNo}</span>
                                </div>

                                {/* <div className="current_status_track">
                                    <span>Status :</span>
                                    <h1>{element?.current_status || trackingData?.shipment_status || orderStatus}</h1>
                                </div> */}

                                <div className="d-flex justify-content-between mt-4">
                                    <h4>{element?.courier_name}</h4>
                                    <div className="tracking_id">
                                        <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                                            <p className="mb-0">Tracking ID</p>
                                            <Link to={trackingData?.track_url || "#"} target="_blank">
                                                View
                                            </Link>
                                        </div>
                                        <span>{element?.awb_code}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="mt-4">
                        {shipmentActivities.map((activity, i) => (
                            <div key={i}>
                                <div className="d-flex activities">
                                    <div>
                                        <span>{formatDate1(activity?.date)}</span>
                                    </div>
                                    <div>
                                        <div className="activity">
                                            <span className="activity_heading">Activity :</span>
                                            <span>{activity?.activity}</span>
                                        </div>
                                        <div className="location">
                                            <span className="location_heading">Location :</span>
                                            <span>{activity?.location}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="sapreatar"></div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="track_order_status">
                    {orderStatus === "pending"
                        ? "Your order is being processed."
                        : orderStatus || "Data Not Found"}
                </div>
            )}
        </div>
    );
};

export default TrackOrder;
